// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604300001/js/" + chunkId + "." + {"44":"3a3f03b3","225":"8c01a447","481":"f1dccebc","486":"fdb1fd40","770":"c88357ce"}[chunkId] + ".0.6324011009961068.chunk.js";
};